import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layer-options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_btn, {
      class: "layer-options-btn",
      square: "",
      icon: "layers",
      title: "Cambiar estilo del mapa"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_menu, {
          cover: "",
          anchor: "bottom right"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMapStyle('mapbox://styles/mapbox/streets-v9')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Streets")
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setMapStyle('mapbox://styles/mapbox/outdoors-v11')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Outdoors")
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setMapStyle('mapbox://styles/mapbox/light-v10')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Light")
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMapStyle('mapbox://styles/mapbox/dark-v10')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Dark")
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setMapStyle('mapbox://styles/mapbox/satellite-v9')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Satellite")
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setMapStyle('mapbox://styles/mapbox/satellite-streets-v11')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Satellite Streets")
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setMapStyle('mapbox://styles/mapbox/traffic-day-v2')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Traffic Day")
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                  clickable: "",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setMapStyle('mapbox://styles/mapbox/traffic-night-v2')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Traffic Night")
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}